module.exports = __webpack_public_path__ + "img/DE01577.e04eea44.png";